const assets = [
  {
    'name': 'floor',
    'x': 0,
    'y': 0,
    'w': 5760,
    'h': 3240,
    'assets': [
      {'src': '/images/objects/floor.png'},
    ]
  },
  {

    'name': 'wall',
    'x': 0,
    'y': 0,
    'w': 5760,
    'h': 2357,
    'assets': [
      {'src': '/images/objects/wall_1.jpg'},
      {'src': '/images/objects/wall_2.jpg'},
    ]
  },
  {
    'name': 'rug',
    'x': 700,
    'y': 2768,
    'w': 3997,
    'h': 471,
    'assets': [
      {'src': '/images/objects/rug_1.png'},
      {'src': '/images/objects/rug_2.png'},
    ]
  },
  {
    'name': 'outside',
    'x': 4326,
    'y': 340,
    'w': 1145,
    'h': 1341,
    'assets': [
      {'src': '/images/objects/snowy.gif'},
      {'src': '/images/objects/rain.gif'},
    ]
  },
  {
    'name': 'window_frame',
    'x': 4250,
    'y': 244,
    'w': 1334,
    'h': 1480,
    'assets': [
      {'src': '/images/objects/window.png'},
    ]
  },
  {
    'name': 'picture',
    'x': 229,
    'y': 560,
    'w': 828,
    'h': 546,
    'assets': [
      {'src': '/images/objects/picture_happy_holidays.png'},
      {'src': '/images/objects/picture_hustle_meets_heart.png'},
    ]
  },
  {
    'name': 'picture_frame',
    'x': 131,
    'y': 464,
    'w': 1065,
    'h': 792,
    'assets': [
      {'src': '/images/objects/picture_frame.png'},
    ]
  },
  {
    'name': 'card_1',
    'x': 2559,
    'y': 424,
    'w': 258,
    'h': 143,
    'assets': [
      {'src': '/images/objects/card_1.png'},
      {'src': '/images/objects/card_2.png'},
    ],
  },
  {
    'name': 'card_2',
    'x': 2959,
    'y': 424,
    'w': 258,
    'h': 143,
    'assets': [
      {'src': '/images/objects/card_1.png'},
      {'src': '/images/objects/card_2.png'},
    ],
  },




  {
    'name': 'books_shadow',
    'x': 1350,
    'y': 140,
    'w': 842,
    'h': 441,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/books_shadow.png'},
    ],
  },
  {
    'name': 'books',
    'x': 1559,
    'y': 290,
    'w': 413,
    'h': 297,
    'assets': [
      {'src': '/images/objects/books.png'},
    ],
  },
  {
    'name': 'candle_1_glow',
    'x': 1759,
    'y': 80,
    'w': 893,
    'h': 779,
    'flicker': true,
    'mixBlendMode': 'screen',
    'opacity': '80%',
    'assets': [
      {'src': '/images/objects/candles_glow.png'},
    ],
  },
  {
    'name': 'candle_1',
    'x': 2059,
    'y': 364,
    'w': 258,
    'h': 213,
    'assets': [
      {'src': '/images/objects/candles_1.png'},
    ],
  },
  {
    'name': 'candle_2_glow',
    'x': 3059,
    'y': 80,
    'w': 893,
    'h': 779,
    'flicker': true,
    'mixBlendMode': 'screen',
    'opacity': '80%',
    'assets': [
      {'src': '/images/objects/candles_glow.png'},
    ],
  },
  {
    'name': 'candle_2',
    'x': 3359,
    'y': 360,
    'w': 258,
    'h': 213,
    'assets': [
      {'src': '/images/objects/candles_2.png'},
    ],
  },
  {
    'name': 'firepoker_shadow',
    'x': 4090,
    'y': 1500,
    'w': 417,
    'h': 1175,
    'assets': [
      {'src': '/images/objects/firepoker_shadow.png'},
    ]
  },
  {
    'name': 'plant_shadow',
    'x': 4090,
    'y': 1600,
    'w': 417,
    'h': 1175,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/plant_shadow.png'},
    ]
  },
  {
    'name': 'firepoker',
    'assets': [
      {
        'x': 4090,
        'y': 1500,
        'w': 365,
        'h': 1118,
        'shadow': 'firepoker_shadow',
        'src': '/images/objects/firepoker.png',
      },
      {
        'x': 4000,
        'y': 1600,
        'w': 857,
        'h': 960,
        'shadow': 'plant_shadow',
        'src': '/images/objects/plant.png',
      },
    ]
  },
  {
    'name': 'fire',
    'x': 2100,
    'y': 1449,
    'w': 1314,
    'h': 817,
    'assets': [
      {'src': '/images/objects/fire2.gif'},
    ]
  },
  {
    'name': 'fireplace_shadow',
    'x': 1336,
    'y': 453,
    'w': 2815,
    'h': 2131,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/fireplace_1_shadow.png'},
    ]
  },
  {
    'name': 'fireplace_shadow_2',
    'x': 1336,
    'y': 453,
    'w': 2815,
    'h': 2131,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '100%',
    'assets': [
      {'src': '/images/objects/fireplace_2_shadow.png'},
    ]
  },
  {
    'name': 'fireplace',
    'assets': [
      {
        'x': 1336,
        'y': 553,
        'w': 2815,
        'h': 2131,
        'shadow': 'fireplace_shadow',
        'src': '/images/objects/fireplace.png',
      },
      {
        'x': 1380,
        'y': 565,
        'w': 2749,
        'h': 2044,
        'shadow': 'fireplace_shadow_2',
        'src': '/images/objects/fireplace_2.png',
      },
    ]
  },
  {
    'name': 'garland_shadow',
    'x': 1548,
    'y': 529,
    'w': 2526,
    'h': 443,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/garland_top_shadow.png'},
    ]
  },
  {
    'name': 'garland',
    'assets': [
      {
        'x': 1548,
        'y': 559,
        'w': 2426,
        'h': 443,
        'shadow': 'garland_shadow',
        'src': '/images/objects/garland_top.png'
      },
      {
        'x': 1360,
        'y': 170,
        'w': 2751,
        'h': 443,
        'src': '/images/objects/garland_bottom.png'
      },
    ]
  },
  {
    'name': 'stocking_shadow',
    'x': 1588,
    'y': 565,
    'w': 382,
    'h': 739,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/stocking_shadow.png'},
    ]
  },
  {
    'name': 'stocking',
    'x': 1638,
    'y': 565,
    'w': 382,
    'h': 739,
    'assets': [
      {'src': '/images/objects/stocking.png'},
    ]
  },
  {
    'name': 'chair_shadow',
    'x': 4238,
    'y': 2615,
    'w': 1550,
    'h': 505,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/chair_shadow.png'},
    ]
  },
  {
    'name': 'chair',
    'x': 4238,
    'y': 1495,
    'w': 1517,
    'h': 1538,
    'assets': [
      {'src': '/images/objects/chair.png  '},
    ]
  },
  {
    'name': 'animals',
    'x': 4530,
    'y': 1810,
    'w': 876,
    'h': 387,
    'assets': [
      {'src': '/images/objects/cat.png'},
      {'src': '/images/objects/dog.png'},
    ]
  },
  {
    'name': 'bench_shadow',
    'x': 0,
    'y': 2550,
    'w': 1214,
    'h': 154,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/bench_shadow.png'},
    ]
  },
  {
    'name': 'bench',
    'x': 0,
    'y': 2060,
    'w': 1355,
    'h': 664,
    'assets': [
      {'src': '/images/objects/bench.png'},
    ]
  },
  {
    'name': 'radio',
    'x': 864,
    'y': 1755,
    'w': 408,
    'h': 354,
    'action': 'music',
    'assets': [
      {'src': '/images/objects/radio.png'},
    ],
    'child': {
      'name': 'music_notes',
      'x': 920,
      'y': 1555,
      'w': 254,
      'h': 300,
      'mixBlendMode': 'color-burn',
      //'opacity': '60%',
      'src': '/images/objects/music_notes.gif',
    }
  },


  {
    'name': 'pillow_shadow',
    'x': 0,
    'y': 2025,
    'w': 490,
    'h': 145,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/pillow_shadow.png'},
    ]
  },
  {
    'name': 'pillow',
    'x': 0,
    'y': 1524,
    'w': 631,
    'h': 582,
    'assets': [
      {'src': '/images/objects/pillow.png'},
    ]
  },
  {
    'name': 'wood_shadow',
    'x': 705,
    'y': 2500,
    'w': 1131,
    'h': 431,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '80%',
    'assets': [
      {'src': '/images/objects/basket_of_firewood_shadow.png'},
    ]
  },
  {
    'name': 'wood',
    'x': 885,
    'y': 2200,
    'w': 997,
    'h': 557,

    'assets': [
      {'src': '/images/objects/basket_of_firewood.png'},
    ]
  },


  {
    'name': 'coffee_shadow',
    'x': 3500,
    'y': 2880,
    'w': 997,
    'h': 352,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '80%',
    'assets': [
      {'src': '/images/objects/coffee_shadow.png'},
    ]
  },
  {
    'name': 'coffee_table',
    'x': 3289,
    'y': 2420,
    'w': 1078,
    'h': 702,
    'assets': [
      {'src': '/images/objects/coffee_table.png'},
    ]
  },
  {
    'name': 'blanket_shadow',
    'x': 129,
    'y': 2890,
    'w': 1295,
    'h': 350,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '100%',
    'assets': [
      {'src': '/images/objects/blanket_shadow.png'},
    ]
  },
  {
    'name': 'blanket',
    'x': 429,
    'y': 2720,
    'w': 1029,
    'h': 358,
    'assets': [
      {'src': '/images/objects/blanket.png'},
    ]
  },
  {
    'name': 'book_shadow',
    'x': 1229,
    'y': 2920,
    'w': 767,
    'h': 254,
    'flicker': true,
    'mixBlendMode': 'color-burn',
    'opacity': '60%',
    'assets': [
      {'src': '/images/objects/book_shadow.png'},
    ]
  },
  {
    'name': 'book',
    'x': 1289,
    'y': 2920,
    'w': 721,
    'h': 214,
    'assets': [
      {'src': '/images/objects/book.png'},
    ]
  },
  {
    'name': 'drink',
    'assets': [
      {
        'x': 3780,
        'y': 2280,
        'w': 244,
        'h': 235,
        'src': '/images/objects/drink-coffee.png'
      },
      {
        'x': 3689,
        'y': 2330,
        'w': 354,
        'h': 186,
        'src': '/images/objects/drink-tea.png'
      },
    ],
    'child': {
      'x': 3735,
      'y': 2030,
      'w': 254,
      'h': 350,
      'name': 'steam',
      'mixBlendMode': 'lighten',
      'opacity': '40%',
      'filter': 'blur(2px)',
      'src': '/images/objects/steam.gif',
    }
  },
  {
    'name': 'feet',
    'x': 2400,
    'y': 2408,
    'w': 517,
    'h': 829,

    'assets': [
      {'src': '/images/objects/feet.png'},
    ]
  },
];

export default assets;